<template>
  <div>
    <!-- Iniciar Atendimento Modal -->
    <div
      class="modal fade"
      id="iniciarAtendimentoModal"
      tabindex="-1"
      role="dialog"
      data-backdrop="static" data-keyboard="false"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-total modal-dialog33 modal-dialog-scrollable" role="document">
        <div class="modal-content modal-content-total modal-content22">
          <div class="modal-header d-flex" v-if="marcacao">
            <paciente-titulo
              :paciente="marcacao.paciente"
              :cadastro_temporario="marcacao.cadastro_temporario"
              :marcacao="marcacao"
            />
            <div class="d-flex justify-content-end">
              <div class="position-absolute mr-4">
                <az-single-image-loader
                    v-if="marcacao && marcacao.id_paciente && ( marcacao.paciente.logo || !$store.state.loading )"
                    titulo="Foto"
                    :single="true"
                    :btnlinha="marcacao.paciente.logo ? true : false"
                    :arquivo="marcacao.paciente.logo"
                    :parms="{ model_type: 'pessoa', model_id: marcacao.id_paciente, cadastro_medico: true, tipo_especial: 'logo' }"
                    @sync="sync_logo"
                    :block_size_alert="true"
                    service="pacientes"></az-single-image-loader>
              </div>

              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div class="modal-body" v-if="marcacao && marcacao.paciente" ref="modal_recep_body">
            <!-- && marcacao.id_paciente -->
            <div class="d-flex justify-content-center text-center mb-0 pb-0">
              <etapas-atendimento :marcacao="marcacao" :etapa="etapa"></etapas-atendimento>
            </div>

            <!-- Abrindo -->
            <div v-if="abrindo">
              <az-loading class="my-3" v-if="abrindo" />
            </div>

            <div v-show="!abrindo">

              <div class=" pt-1" v-if="etapa == 1">
                <div class="small text-muted text-right" v-if="marcacao.paciente.inicio_cadastro">{{ marcacao.paciente.inicio_cadastro.slice(11,19) }}</div>

                <!-- Dados Pessoais -->
                <div class="mb-2" v-if="marcacao.paciente && !marcacao.paciente.id_pessoa && !marcacao.paciente.verificado">
                  <cadastro-paciente-primeira-vez ref="cadPaciente1" v-model="marcacao.paciente" :marcacao="marcacao" @refresh="$emit('refresh')" />
                </div>
                <div class="mb-2" v-else>
                  <cadastro-paciente
                    v-model="marcacao.paciente"
                    :marcacao="marcacao"
                    formName="cadpac"
                    :editar="true"
                    :noButtons="true"
                    ref="cadPaciente"
                    :validate="validarCadastro"
                    :sus_block_obrig="sus_block_campo_obrig"
                    :sus_block_cns_obrig="sus_block_cns_obrig"
                  />
                </div>
              </div>

              <div class="" v-if="etapa == 2">
                <!-- Procedimentos -->
                <div class="mb-2">
                  <Procedimentos
                    ref="proced"
                    posUpdate="proxima_etapa"
                    :idMarcacao="marcacao.id_marcacao"
                    :validacao="validarProcedimento"
                    :altera_prof="altera_prof"
                    @syncpac="syncpac"
                  ></Procedimentos>
                </div>
              </div>

              <div class="" v-if="etapa == 3">
                <!-- Pagamento -->
                <div class="mb-2" v-if="tem_valor_particular">
                  <pagamento ref="pagamento" :validate="validarPagamento" :marcacao="marcacao" @reabrir="reabrir" @refresh="refresh_and_go ()" />
                </div>
              </div>

              <div class="" v-if="etapa == 4">
                <!-- Impressão do Recibo -->
                <recibo-particular ref="recibo" :marcacao="marcacao" @reabrir="reabrir" @encaminhar="$emit('encaminhar', $event)" />
              </div>

              <div class="" v-if="etapa == 8">
                <div class="mb-2">
                  <guias ref="listaguias" 
                    :marcacao="marcacao" 
                    @refresh="refresh_and_go ()" 
                    @reabrir="reabrir" 
                    @novo="novo_atendimento"
                    @encaminhar="$emit('encaminhar', $event)" 
                    @atualizar_progresso="atualizar_progresso"
                    :tem_assinar_guia="paciente_assinar_guia || paciente_assinar_guia_zerodox" />
                </div>
              </div>

              <!-- Pré Atendimento -->
              <div class="" v-if="etapa == 9">
                <div class="my-2">
                  <pre-atendimento-edit :validate="validate" :marcacao="marcacao" v-model="pre_atendimentos" @refresh="refresh_and_go ()" />
                </div>
              </div>

            </div>

          </div>

          <div class="modal-footer d-flex justify-content-between">
            <div class="d-flex">
              <az-audit-log-button model="marcacao" v-if="marcacao" :id="marcacao.id_marcacao" /> <!-- && $util.acesso_a_config() -->
              <button type="button" class="btn btn-outline-primary ml-2" title="Instruções" @click="abrir_instrucoes()">
                <i class="fa-solid fa-circle-info"></i>
              </button>
              <div class="ml-2">
                <div v-if="marcacao">
                  <span class="small text-muted" v-if="marcacao.id_atendimento">
                    #{{ marcacao.id_atendimento }}
                  </span>
                  <i class="fa fa-angle-double-right ml-3" aria-hidden="true" tooltip="Outras Marcações"
                    v-if="marcacao && marcacao.tem_outras"></i>
                  <span class="small text-muted" v-if="marcacao && marcacao.st_id_externo">
                    <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                    {{ marcacao.st_id_externo }}
                  </span>
                </div>
              </div>
            </div>

            <div>
              <button
                type="button"
                class="btn btn-outline-secondary mr-2"
                @click="voltar ()"
                v-if="etapa > 1"
              >Voltar</button>

              <button
                type="button"
                class="btn btn-primary mr-2"
                v-if="( (paciente_assinar_guia || paciente_assinar_guia_zerodox) && etapa == 8 && marcacao && marcacao.plano && marcacao.plano.id_operadora != 1 )"
                :disabled="passando || refreshing || $store.state.loading"
                @click="assinar_guias ()"
              >Assinar Guias </button>

              <button
                class="btn btn-success"
                type="button"
                @click="proxima_etapa ()"
                :disabled="passando || refreshing || $store.state.loading"
              >
                <span class="spinner-border spinner-border-sm fa-fw mr-2" v-if="passando || $store.state.loading"></span>
                <span v-else-if="nome_botao_etapa == 'Próximo'">
                  <i class="fa-solid fa-angle-right mr-3"></i>
                </span>
                <span>{{ nome_botao_etapa }}</span>
              </button>

              <button
                class="btn btn-outline-success ml-2"
                type="button"
                @click="fechar (etapa)"
                v-if="( etapa == 4 && marcacao && marcacao.plano && marcacao.plano.id_operadora == 1 ) || etapa == 8"
                :disabled="passando || $store.state.loading"
              >
                Concluir
              </button>

              <button
                class="btn btn-outline-success ml-2"
                type="button"
                @click="ir_para_etapa(8)"
                v-if="( etapa == 4 && marcacao && marcacao.plano && marcacao.plano.id_operadora != 1 )"
                :disabled="passando || $store.state.loading"
              >
                Guias
              </button>
            </div>
          </div>

          <!--
                <div class="modal-footer d-flex justify-content-between">
                    <pre>{{ marcacao }}</pre>
                </div>
          -->
        </div>
      </div>
    </div>

    <!-- Modal Instruções -->
    <div class="modal fade" id="instrucoesModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-dialog3 modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Instruções</h5>
              <button type="button" class="close" @click="fechar_modal('instrucoesModal')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <az-instrucoes contexto="R" ref="instrucoes" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="fechar_modal('instrucoesModal')">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <DocumentoIPSign
        ref="documentoIPSignRef"
        :model_id="marcacao ? marcacao.id_marcacao : null"
        model_type="marcacao"
    />

    <DocumentoZerodox
        ref="documentoZerodoxRef"
        :model_id="marcacao ? marcacao.id_marcacao : null"
        model_type="marcacao"
    />
  </div>
</template>

<script>
import $ from "jquery";
import _ from "lodash";
import CadastroPaciente from "../../shared/CadastroPaciente.vue";
import CadastroPacientePrimeiraVez from './CadastroPacientePrimeiraVez.vue';
import PacienteTitulo from "../../shared/PacienteTitulo.vue";
import Procedimentos from "./Procedimentos.vue";
import EtapasAtendimento from "./EtapasAtendimento.vue";
import Guias from "../../tiss/Guias.vue";
import Pagamento from "./Pagamento.vue";
import ReciboParticular from "./ReciboParticular.vue";
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import PreAtendimentoEdit from './PreAtendimentoEdit.vue';
import AzLoading from '../../util/AzLoading.vue';
import AzSingleImageLoader from '../../util/AzSingleImageLoader.vue';
import AzInstrucoes from '../../util/AzInstrucoes.vue';
import DocumentoIPSign from "../../shared/DocumentoIPSign.vue";
import DocumentoZerodox from "../../shared/DocumentoZerodox.vue";

export default {
  data() {
    return {
      marcacao: null,
      original: null,
      etapa: 1,
      passando: false,
      validarCadastro: false,
      validarProcedimento: false,
      validarPagamento: false,
      pre_atendimentos: null,
      refreshing: false,
      abrindo: false,
      validate: false, 
      paciente_assinar_guia: false,
      sus_block_campo_obrig: false, 
      paciente_assinar_guia_zerodox: false,
      pode_ver_classes: null, 
    };
  },

  props: ['altera_prof'], 

  components: {
    CadastroPaciente,
    PacienteTitulo,
    Procedimentos,
    EtapasAtendimento,
    Guias,
    Pagamento,
    ReciboParticular,
    CadastroPacientePrimeiraVez,
    AzAuditLogButton,
    PreAtendimentoEdit,
    AzLoading,
    AzSingleImageLoader,
    AzInstrucoes, 
    DocumentoIPSign,
    DocumentoZerodox,
  },

  computed: {
    is_vtr: function () { 
        return this.$store.state.user && this.$store.state.user.vtr;
    },

    nome_botao_etapa: function() {
      let nome = "Próximo";

      switch (this.etapa) {
        case 4:
          nome = "Imprimir";
          break;
        case 8:
          nome = "Visualizar Guias";
          break;
      }

      return nome;
    },

    tem_valor_particular: function() {

      return this.marcacao
        && ( this.marcacao.fl_particular
            || this.marcacao.tem_pagamento_particular 
            || ( this.marcacao.atendimento
                  && this.marcacao.atendimento.atendimento_procedimentos
                  && this.marcacao.atendimento.atendimento_procedimentos.findIndex(item =>
                    item.id_plano_particular ||
                    item.atendimento_procedimento_consumos.findIndex(cns => cns.id_plano) >= 0
                  ) >= 0
            )
        );

    },
  },

  methods: {
    assinar_guias (id_guia = null) {
        if (!this.marcacao || (!_.get(this.marcacao, 'atendimento.guias') && !_.get(this.marcacao, 'outras'))) {
            this.$toast.add({
                severity: "error",
                summary: "Atenção",
                detail: "Não é possível assinar as guias.",
                life: 3000
            });
            return;
        }

        console.log('marcacao', this.marcacao)

        const guias = _.get(this.marcacao, 'atendimento.guias', []);
        let idGuias = id_guia ? [id_guia] : _.map(guias.filter(guia => !guia.assinada && guia.ch_status != 'CA' && guia.ch_status != 'SL'), 'id_guia');

        if ( !idGuias.length && !id_guia ) {
          const outrasGuias = _.flatMap(_.get(this.marcacao, 'outras', []), outra => _.get(outra, 'atendimento.guias', []));

          idGuias = _.map(outrasGuias.filter(guia => !guia.assinada && guia.ch_status != 'CA' && guia.ch_status != 'SL'), 'id_guia');
        }

        if ( !idGuias.length ) { 
            this.$toast.add({
                severity: "error",
                summary: "Atenção",
                detail: "Nenhuma guia disponível para assinatura.",
                life: 3000
            });
            return;
        }

        this.$refs.listaguias.print(true, null, () => { 

            if (this.paciente_assinar_guia_zerodox) {
                this.$refs.documentoZerodoxRef.show_guias(
                    idGuias, 
                    _.get(this.marcacao, 'paciente.cadastro.st_email'), 
                    _.get(this.marcacao, 'paciente.cadastro.st_cpf'), 
                    _.get(this.marcacao, 'nome_paciente'),  
                    "", // unidade 
                    "", // operadora 
                    _.get(this.marcacao, 'paciente.cadastro.dt_nascimento'), // dt_nascimento 
                );
            } else {
                this.$refs.documentoIPSignRef.show_guias(
                    idGuias, 
                    _.get(this.marcacao, 'paciente.cadastro.st_email'), 
                    _.get(this.marcacao, 'paciente.cadastro.st_cpf'), 
                    _.get(this.marcacao, 'nome_paciente'),  
                    "", // unidade 
                    "", // operadora 
                    "", // chave_assinatura 
                    0, // qtd_ocor_ass 
                    ""// dt_nascimento 
                );
            }

        }); 

        // this.$refs.documentoIPSignRef.show(
        //     base64data,
        //     "Assinar guias",
        //     email,
        //     cpf,
        //     nome,
        //     unidade,
        //     operadora,
        //     this.documento.st_chave_assinatura_ipsign,
        //     qtdOcorrenciasAss,
        //     dt_nascimento
        // );
    },

    abrir_instrucoes () { 
      let base = this.etapa == 2 ? this.$refs.proced.dados : this.marcacao;

      this.$refs.instrucoes.reset();
      this.$refs.instrucoes.buscar_plano(base);

      $("#instrucoesModal").modal("show"); 
    },

    atualizar_progresso(item) { 
      this.$emit('atualizar_progresso', item);
    },

    novo_atendimento(marcacao) {
      $('.modal').modal('hide');

      this.$emit('novo', marcacao);
    },

    sync_logo(logo) {
      this.marcacao.paciente.logo = logo;
    },

    syncpac(paciente) {
      this.marcacao.paciente = paciente;
    },

    reabrir(item) {
      console.log('reabrir', item);

      if ( _.get(item, 'ir_para_etapa') ) {
        this.abrir(item, _.get(item, 'ir_para_etapa'));
      } else {
        this.abrir(item);
      }
    },

    fechar_modal(name) { 
      $("#" + name).modal("hide");  
    },

    fechar (etapa) {

      if ( etapa == 8 && this.marcacao && this.marcacao.atendimento && this.marcacao.atendimento.guias ) {
        this.$refs.listaguias.print(false, 'iniciarAtendimentoModal');

        if ( !this.marcacao.atendimento.guias.length ) { 
          $(".modal").modal("hide");  
        }
      } else {
        if ( this.etapa == 4 && this.marcacao && this.marcacao.plano && this.marcacao.plano.id_operadora == 1 ) { 
          this.$util.atualizar(this, { 
            service: 'atendimentos',
            func: 'fim_recepcao',
            dados: {
              id_atendimento: this.marcacao.id_atendimento,
              outras: this.marcacao.outras 
                ? this.marcacao.outras.map(item => item.id_atendimento)
                : null
            },
            callback: () => { 
              this.fechar_modal_etapa();
            }
          });

          return;
        }

        this.fechar_modal_etapa();

        /*
        if ( window.redir == 'labs' && this.marcacao && !this.marcacao.st_id_externo ) {
          this.$util.atualizar(this, { 
            service: 'terceiros',
            func: 'reintegrar_labs',
            dados: {
              lista: [this.marcacao.id_marcacao],
              integrar: true,
            },
            callback: () => {
              $("#iniciarAtendimentoModal").modal("hide");
            }
          });
        } else { 
          $("#iniciarAtendimentoModal").modal("hide");
        }
        */
      }
    },

    fechar_modal_etapa() {
      if ( window.redir == 'labs' && this.marcacao && !this.marcacao.st_id_externo ) {
        this.$util.atualizar(this, { 
          service: 'terceiros',
          func: 'reintegrar_labs',
          dados: {
            lista: [this.marcacao.id_marcacao],
            integrar: true,
          },
          callback: () => {
            $("#iniciarAtendimentoModal").modal("hide");
          }
        });
      } else { 
        $("#iniciarAtendimentoModal").modal("hide");
      }
    },
    abrir(marcacao, etapa = 1, local = null, callback = null) {
      //this.etapa = etapa;
      this.abrindo = true;
      this.original = marcacao;
      this.validarCadastro = false;
      this.validarProcedimento = false;
      this.validarPagamento = false;

      this.marcacao = _.cloneDeep(marcacao);

      $("#iniciarAtendimentoModal").modal("show");

      if (!this.marcacao.paciente || etapa == 1 || etapa == 4) {

        this.marcacao.paciente = {};

        let query = {
          q: [
            {
              name: "pacientes.show",
              id: "item",
              parms: {
                id: marcacao.id_paciente
                  ? marcacao.id_paciente
                  : marcacao.id_cadastro_temporario,
                tp: marcacao.id_paciente ? "cad" : "tmp",
                id_plano: marcacao.id_plano,
                id_marcacao: marcacao.id_marcacao,
                local: local, 
                cadastro: true,
                with: [
                  "atendimentoPacotes",
                  "logo.arquivo"
                ]
              },
              configs: [
                'atend-sus-block-campo-obrig',
                'sus-arquivo-apac-com-cpf'
              ], 
            }
          ]
        };

        this.$store.commit('loading', true);

        this.axios
          .post("/aql?a=pacientes.show", query)
          .then(res => {
            this.marcacao.paciente = res.data.item.data;

            this.sus_block_cns_obrig = ( res.data.configs_item && res.data.configs_item['sus-arquivo-apac-com-cpf'] ) 
              ? true
              : false;

            this.sus_block_campo_obrig = ( res.data.configs_item && res.data.configs_item['atend-sus-block-campo-obrig'] ) 
              ? true
              : false;

            if ( this.is_vtr ) { 
                this.marcacao.paciente.cadastro.fl_estrangeiro = true; 
            } 

            this.$forceUpdate();
          })
          .finally(() => {
            
            this.$store.commit('loading', false);

            if ( etapa == 4 ) { 
              if ( this.$refs.recibo ) { 
                this.$refs.recibo.load(this.marcacao.id_marcacao);
              }
              
              this.refresh_and_go(4);
            } else if ( callback ) { 
                callback(); 
            } else { 
              this.ir_para_etapa(etapa);
            }

          });
        return;

      } else {

        this.ir_para_etapa(etapa);
        
      }

    },

    proxima_etapa() {
      if (this.etapa == 1) {
        if ( this.marcacao.paciente && !this.marcacao.paciente.id_pessoa && !this.marcacao.paciente.verificado ) {

          if ( !this.sus_block_campo_obrig 
            && !_.get(this.marcacao, 'paciente.cadastro.st_cpf') 
            && _.get(this.marcacao, 'paciente.paciente_unidade.plano.operadora.fl_sus') 
            && !_.get(this.marcacao, 'paciente.paciente_unidade.st_sus') ) {

            this.$toast.add({
              severity: "error",
              summary: "Atenção",
              detail: "Necessário informar o CNS para confirmar o cadastro do paciente.",
              life: 3000
            });
            return;

          }  

          if ( $('#botao-incluir-paciente').length ) {
            this.$refs.cadPaciente1.incluir();
            this.$forceUpdate();
            return;
          }

          this.$toast.add({
            severity: "error",
            summary: "Atenção",
            detail: "Necessário informar o CPF para confirmar o cadastro do paciente.",
            life: 3000
          });

          return;
        }

        this.validarCadastro = true;
        this.validarCampos(this.atualizar_dados_paciente);
      } else if (this.etapa == 2) {
        this.validarProcedimento = true;
        this.validarCampos(this.atualizar_procedimentos);
      } else if (this.etapa == 9) {
        this.validarCampos(this.atualizar_pre_atend);
      } else if (this.etapa == 3) {
        this.validarPagamento = true;
        this.validarCampos(this.atualizar_pagamento);
      } else if (this.etapa == 8) {
        this.$refs.listaguias.print();
      } else if (this.etapa == 4) {
        if (this.$refs.recibo.dados) {
          this.$refs.recibo.imprimirRecibo();
        }
      }
    },

    validarCampos(action) {
      this.$nextTick(() => {
        let invalids = $(".invalid");

        if (invalids.length && $(".invalid").is(":visible")) {
          this.$toast.add({
            severity: "error",
            summary: "Atenção",
            detail: "Verificar preenchimento dos campos.*",
            life: 3000
          });
        } else {
          action();
        }
      });
    },

    voltar() {
      if (this.etapa == 8) {
        this.ir_para_etapa(2);
      } else {
        this.ir_para_etapa(this.etapa - 1);
      }
    },

    salvar_paciente () {

      this.passando = true;

      const start = this.marcacao.paciente.inicio_cadastro;

      let query = {
        q: [
          {
            name: "pacientes.store",
            id: "retorno",
            parms: {
              paciente: this.marcacao.paciente,
              cadastro_temporario: this.marcacao.cadastro_temporario,
              marcacao: this.marcacao,
              id_unidade_operacao: this.$util.getCookie('id_unidade_operacao'),
              id_recepcao: this.$util.getCookie('id_recepcao')
            }
          }
        ]
      };

      this.axios
        .post("/aql?a=pacientes.store", query)
        .then(res => {
          if (res.data.retorno && res.data.retorno.status == 200) {

            if ( res.data.retorno.data.id_pessoa ) {
                this.marcacao.paciente = res.data.retorno.data;
                this.marcacao.id_plano = this.marcacao.paciente.paciente_unidade.id_plano;
                this.marcacao.plano = this.marcacao.paciente.paciente_unidade.plano;
            }

            query = {
              q: [
                {
                  name: "marcacoes.iniciar",
                  id: "retorno",
                  parms: {
                    id: this.marcacao.id_marcacao,
                    start: start,
                    paciente: this.marcacao.paciente, 
                  }
                }
              ]
            };

            this.axios.post("/aql?a=marcacoes.iniciar", query).then(res => {
              if (res.data.retorno && res.data.retorno.status == 200) {

                if ( !this.marcacao.id_atendimento ) {

                  let action = 'atender';
                  let label = ( 'UN:' + this.marcacao.id_unidade_operacao );

                  this.$gtag.event(action, {
                      'event_category': window.redir,
                      'event_label': label,
                      'value': 1
                  });

                }

                this.$emit("refresh");
                this.ir_para_etapa(2);
                this.$forceUpdate();
              }
            });
          }
        })
        .finally(() => {
          this.passando = false;
        });

    },

    atualizar_dados_paciente() {
      if (
        this.marcacao.paciente &&
        this.marcacao.paciente.cadastro &&
        this.marcacao.paciente.cadastro.endereco
      ) {
        if (this.marcacao.paciente.cadastro.endereco.cidade) {
          this.marcacao.paciente.cadastro.endereco.id_cidade = this.marcacao.paciente.cadastro.endereco.cidade.id_cidade;
        } else {
          this.marcacao.paciente.cadastro.endereco.id_cidade = null;
        }
      }

      if ( !this.marcacao.paciente.id_pessoa ) {

        if ( this.marcacao.paciente.cadastro.fl_estrangeiro && !this.marcacao.paciente.cadastro.st_cpf ) {

          this.salvar_paciente ();

        } else if ( this.marcacao.paciente.cadastro.idade_anos >= 18 || this.marcacao.paciente.cadastro.st_cpf ) {

          this.$store.commit('loading', true);

          this.$util.loadItem(this, {
              service: 'pacientes',
              func: 'checar_duplicidade',
              parms: {
                paciente: this.marcacao.paciente,
              }
          })
          .then(lista => {
              if ( lista.length ) {
                  alert('Paciente já cadastrado.');
                  return;
              } else {
                  this.salvar_paciente ();
              }
          })
          .finally(() => {
              this.$store.commit('loading', false);
          });

        } else {

          this.salvar_paciente ();

        }

      } else {

          this.salvar_paciente();

      }

    },

    atualizar_pre_atend() {

      this.$util.atualizar(this, {
        service: 'documentos_pre_atendimento',
        func: 'store_all',
        dados: this.pre_atendimentos,
        callback: () => {
          this.refresh_and_go(this.tem_valor_particular ? 3 : 8);
        }
      });

    },

    atualizar_procedimentos() {
      let item = this.$refs.proced.temItemBloqueado();

      if (item ) {
        const id_rest = _.get(item, 'restricao.id_restricao_operadora', '');

        alert("Item sem cobertura pela operadora. (" + item.procedimento.search + ") " 
          + _.get(item, 'restricao.exibir.texto', '')
          + ( id_rest ? ' => #' + id_rest : '' ) );
        return;
      }

      if ( !this.$refs.proced.validar_solicitantes() ) { 
        return; 
      }

      this.passando = true;
      this.pre_atendimentos = null;
      this.validate = false;

      let retorno = this.$refs.proced.atualizar();

      if ( !retorno ) { 
        this.passando = false;
        return;
      }

      retorno.then(res => {
          if ( res && ( res.data.retorno.status == 200 || res.data.retorno.status == 291 ) ) {
            if ( res.data.retorno.data.msg && res.data.retorno.status == 200 ) {
              this.$toast.add({
                severity: "warn",
                summary: "Atenção",
                detail: res.data.retorno.data.msg,
                life: 3000
              });
            }

            this.refreshing = true;

            if ( res.data.retorno.data.pre_atendimentos && res.data.retorno.data.pre_atendimentos.length ) {
              this.pre_atendimentos = res.data.retorno.data.pre_atendimentos;
              this.refresh_and_go(9);
            } else {
              this.refresh_and_go(99);
            }
          }
        })
        .finally(() => {
          if ( !this.refreshing ) {
            this.refreshing = true;
            this.refresh_and_go(0);
          }

          this.passando = false;
        });
    },

    refresh_and_go(etapa) {
      let guia_tiss = ( etapa == 8 || etapa == 99 || ( !etapa && this.etapa == 8 ) ) ? true : false;

      if ( etapa == 4 && this.marcacao.plano && this.marcacao.plano.id_operadora != 1 ) {
        guia_tiss = true;
      }

      let query = {
        q: [
          {
            name: "marcacoes.show",
            id: "marcacao",
            parms: {
              id: this.marcacao.id_marcacao,
              buscar_outras: true,
              guia_tiss: guia_tiss,
              foto: true,
              recibo: ( etapa == 4 ? true : false ),
              etapa: etapa, 
            }
          },
          {
            name: 'configuracoes.check',
            id: 'paciente_assinar_guia',
            parms: {
                st_slug: 'paciente-assinar-guias-ipsign',
                st_valor: '1',
            }
          },
          {
            name: 'configuracoes.check',
            id: 'paciente_assinar_guia_zerodox',
            parms: {
                st_slug: 'paciente-assinar-guias-zerodox',
                st_valor: '1',
            }
          },
        ]
      };

      this.axios.post("/aql?a=marcacoes.show", query)
        .then(res => {
          if (res.data.marcacao && res.data.marcacao.status == 200) {
            this.marcacao = res.data.marcacao.data;

            if ( etapa )
              this.ir_para_etapa(etapa == 99 ? ( this.tem_valor_particular ? 3 : 8 ) : etapa);

            this.$emit("refresh");
            this.$forceUpdate();
          }

          if (res.data.paciente_assinar_guia.status == 200) {
            this.paciente_assinar_guia = res.data.paciente_assinar_guia.data;
          }

          if (res.data.paciente_assinar_guia_zerodox.status == 200) {
            this.paciente_assinar_guia_zerodox = res.data.paciente_assinar_guia_zerodox.data;
          }
        })
        .finally(() => {
          this.refreshing = false;
        });
    },

    atualizar_pagamento() {
      this.passando = true;

      this.$refs.pagamento
        .atualizar(
          (res) => {
            if ( res )
              this.refreshing = true;
              this.refresh_and_go(4);
          },
          () => {
            this.passando = false;
          });
    },

    ir_para_etapa(etapa) {
      if (this.$refs.modal_recep_body) {
        this.$refs.modal_recep_body.scrollTop = 0;
      }
        
      if ( etapa ) {

        this.etapa = etapa;

        if ( etapa == 1 ) { 

            this.abrir(this.marcacao, 1, null, () => { 
                this.abrindo = false;
            });

        } else if (etapa == 2) {

            this.$nextTick(() => {
                if (this.$refs.proced) {
                    this.$refs.proced.carregar(() => {
                        this.abrindo = false;
                    });
                }
            });

        } else if (etapa == 3) {

            this.$nextTick(() => {
                if (this.$refs.pagamento) {
                    this.$refs.pagamento.abrir(
                        this.marcacao.id_atendimento,
                        () => {
                          this.abrindo = false;
                        }
                    );
                }
            });

        } else if ( etapa == 8 && this.abrindo ) {

          let query = {
            q: [
              {
                name: "marcacoes.show",
                id: "item",
                parms: {
                  id: this.marcacao.id_marcacao,
                  para_atendimento: true,
                  guia_tiss: true,
                  foto: true,
                }
              },
              {
                name: 'configuracoes.check',
                id: 'pode_alterar_data',
                parms: {
                    st_slug: 'alterar-data-guia',
                    st_valor: '1',
                }
              },
              {
                name: 'configuracoes.check',
                id: 'paciente_assinar_guia',
                parms: {
                    st_slug: 'paciente-assinar-guias-ipsign',
                    st_valor: '1',
                }
              },
              {
                name: 'configuracoes.check',
                id: 'paciente_assinar_guia_zerodox',
                parms: {
                    st_slug: 'paciente-assinar-guias-zerodox',
                    st_valor: '1',
                }
              },
            ]
          };

          this.axios
            .post("/aql?a=gmarcacoes.show", query)
            .then(res => {
              console.log(res);

              if (res.data.item.status == 200) {
                this.marcacao = res.data.item.data;
                this.marcacao.pode_alterar_data = false;
              }

              if (res.data.pode_alterar_data.status == 200) {
                this.marcacao.pode_alterar_data = res.data.pode_alterar_data.data;
              }

              if (res.data.paciente_assinar_guia.status == 200) {
                this.paciente_assinar_guia = res.data.paciente_assinar_guia.data;
              }

              if (res.data.paciente_assinar_guia_zerodox.status == 200) {
                this.paciente_assinar_guia_zerodox = res.data.paciente_assinar_guia_zerodox.data;
              }
            })
            .finally(() => {
              this.abrindo = false;
            });

        } else {
          this.abrindo = false;
        }

      }
    },

    refresh_marcacao() {
      let query = {
        q: [
          {
            name: "marcacoes.show",
            id: "marcacao",
            parms: { id: this.marcacao.id_marcacao }
          }
        ]
      };

      return this.axios.post("/aql?a=rmarcacoes.show", query).then(res => {
        if (res.data.marcacao && res.data.marcacao.status == 200) {
          this.marcacao = res.data.marcacao.data;
          this.etapa = 3;
        }
      });
    }
  },

  mounted() {
    //
  },

  updated() {
    $('[data-toggle="tooltip"]').tooltip();
  }
};
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}

.modal-dialog2 {
  width: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}

.modal-dialog3 {
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100%;
  max-height: 100% !important;
}
</style>
